<template>
    <div class="withdraw">
        <div class="placeholder"></div>
        <div class="withdraw-content withdraw-warp">
            <div class="withdraw-title">
                <span @click="$router.back()" >
                    <img src="../../assets/img/wallet/arrow.png" alt="">
                {{$t('withdraw.title')}}
                </span>
            </div>

            <div class="withdraw-num">
                {{balance}}<span></span>
            </div>
            <div class="withdraw-desc">
                {{$t('withdraw.revenue')}} (USDT)
            </div>

            <div class="withdraw-card">
                <div class=title>
                    {{$t('withdraw.amount')}} 
                </div>
                <Field class="ipt" v-model="wdAmount">
                    <template #button>
                        <div>USDT</div>
                    </template>
                </Field>
                <div class="btn" @click="addWD()">{{$t('withdraw.confirm')}} </div>
                <div class="desc">
                    <div class="title">{{$t('withdraw.rule')}}:</div>
                    <div class="text">
                        *{{$t('withdraw.desc')}}

                    </div>
                    <div class="text">*{{$t('withdraw.desc1')}}</div>
                </div>
            </div>

            <div class="withdraw-list">
                <div class="title">{{$t('withdraw.list')}}</div>
                <div class="withdraw-list-item" v-for="(item,i) in pagelist" :key="i">
                    <div class="withdraw-list-item-t">
                        <div>
                            ID:{{item.Coin}}
                            <span class="green">
                                <i></i>
                                {{getPyaState(item.PayState)}}</span>
                        </div>
                        <div>+{{item.Amount}}</div>
                    </div>

                    <div class="withdraw-list-item-b">
                        <div>
                            {{$t('withdraw.time')}} {{formatTime(item.AddTime)}}

                        </div>
                        <div>USDT</div>
                    </div>

                </div>
<!-- 
                <div class="withdraw-list-item">
                    <div class="withdraw-list-item-t">
                        <div>
                            ID:0343BA09001
                            <span class="red">
                                <i></i>
                                {{$t('withdraw.error')}}</span>
                        </div>
                        <div>+1003.33</div>
                    </div>

                    <div class="withdraw-list-item-b">
                        <div>
                            {{$t('withdraw.time')}} 2026.03.22 15:15

                        </div>
                        <div>USDT</div>
                    </div>

                </div> -->
            </div>
        </div>

    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";

import axios from 'axios'
import contractaa from '../contract/index.js'

export default {
    name: "withdraw",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "1",
            show: false,
            value1: '100',
            value2: '134.5',
            value3: '134.5',
            balance:0,
            pagelist:[],
            wdAmount:''
        };
    },
    computed: {},

    methods: {
        getInfo(){
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=withdraw','token='+ _token).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        that.balance = response.data.Message
                        that.pagelist = response.data.Data
                    }

                }
            })
        },
        formatTime(timeStr){
            let clean = timeStr.replace('T',' ').slice(0, -4)
            return clean
        },
        getPyaState(v){
            if(v==0){
                return "待处理"
            }else if(v==1){
                return "成功 "
            }else if(v==2){
                return "失败"
            }

        },
        addWD(){
            let that = this;
            let _token = this.$store.state.loginToken

            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=addwd','token='+ _token+'&amount='+that.wdAmount).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        
                        that.$toast.success(response.data.Message);
                        that.getInfo()
                        that.wdAmount=''
                    }
                    else{
                       
                       that.$toast.fail(response.data.Message);
                    }

                }
            })
        },
    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo()
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.withdraw {
    position: relative;

    .placeholder {
        // height: 50px;
    }

    .withdraw-warp {
        padding: 0 20px;
    }

    &-content {
        margin-top: 15px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;
    }

    &-title {
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;
       >span {
        display: flex;
        align-items: center;
        >img {
            height: 16px;
            width: 16px;
            margin-right: 5px;
        }
       }

     
    }

    &-num {
        font-size: 36px;
        font-weight: bold;
        font-family: DINAlternate, DINAlternate;
        line-height: 42px;
        color: #FFFFFF;
        text-align: center;

        span {
            font-size: 16px;
        }
    }

    &-desc {
        color: #838383;
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 10px;
    }

    &-card {
        margin-top: 20px;
        background: #1B1C1E;
        border-radius: 16px;
        min-height: 279px;
        padding: 15px;

        >.title {
            font-size: 14px;
            color: #C6C6C6;
            line-height: 22px;
            margin-bottom: 5px;
        }

        >.btn {
            background: #FFFFFF;
            border-radius: 25px;
            height: 50px;
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        >.desc {
            >.title {
                margin-bottom: 6px;
                color: #838383;
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
            }

            .text {
                font-size: 14px;
                color: #FFFFFF;
                line-height: 26px;
            }

        }
    }

    &-list {
        margin-top: 20px;

        .title {
            font-size: 16px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 22px;
        }

        &-item {
            margin-top: 10px;
            min-height: 70px;
            background: #1B1C1E;
            border-radius: 16px;
            padding: 16px 15px;

            &-t {
                display: flex;
                justify-content: space-between;
                color: #FFFFFF;
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;

                >div {
                    display: flex;

                }

                span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    font-size: 10px;
                    line-height: 12px;
                    margin-left: 6px;
                    padding: 3px 5px;
                    font-weight: 400;
                    i {
                        margin-right: 3px;
                        display: block;
                        height: 4px;
                        width: 4px;
                        background: #FF523F;
                        border-radius: 50%;
                        ;
                    }

                    &.red {
                        color: #FF523F;
                        background: rgba(255, 82, 63, 0.08);

                        i {
                            background: #FF523F;

                        }

                    }

                    &.green {
                        color: #78E0A4;
                        background: rgba(120, 224, 164, 0.08);

                        i {
                            background: #78E0A4;

                        }
                    }
                }

            }

            &-b {
                margin-top: 4px;
                display: flex;
                justify-content: space-between;

                color: #838383;
                font-size: 10px;
                line-height: 14px;
            }
        }
    }


}
</style>
<style lang="less">
.withdraw-card {
    .ipt {
        margin-bottom: 25px;
        background: #0F0F0F;
        border: 1px solid #313439;
        border-radius: 10px;
        height: 50px;
        padding: 0;
        display: flex;
        align-items: center;
        padding: 0 15px;

        &::after {
            display: none;
        }

        .van-field__button {
            color: #838383;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
        }

        input {
            font-size: 14px;
            line-height: 26px;
            font-size: 14px;
            color: #fff;
        }
    }
}
</style>